import { LocalStorageCart, ShopifyCart } from "./shopify";

export type Actions = "add" | "update" | "remove";

export type CartOperation = {
  action: Actions;
  args: any[];
  timestamp: string;
};

export class CartObserverProvider {
  static init() {
    CartObserverProvider.overrideFetch();
  }

  static overrideFetch() {
    if (!window.location.hostname.includes("culture-circle")) {
      ShopifyCart.overrideFetch({
        add: (args) => this.logCartOperation("add", args),
        update: (args) => this.logCartOperation("update", args),
        remove: (args) => this.logCartOperation("remove", args),
      });
    }

    LocalStorageCart.overrideFetch({
      add: (args) => this.logCartOperation("add", args),
      update: (args) => this.logCartOperation("update", args),
      remove: (args) => this.logCartOperation("remove", args),
    });
  }

  static logCartOperation(action: Actions, args: any[]) {
    const timestamp = new Date().toISOString();
    const current = this.getAllCartOperations();

    current.push({
      action: action,
      args: args,
      timestamp: timestamp,
    });

    sessionStorage.setItem("helium-cart-operations", JSON.stringify(current));

    console.log(`Cart operation logged: ${action} at ${timestamp}`);
  }

  static getCartOperationCount(action: Actions) {
    return this.getAllCartOperations().filter((log) => log.action === action)
      .length;
  }

  static getAllCartOperations() {
    return (JSON.parse(
      sessionStorage.getItem("helium-cart-operations") || "[]",
    ) || []) as CartOperation[];
  }
}
